import { makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { GetReferenceValueSheetByIdResolver } from './resolvers/get-reference-value-sheet-by-id.resolver';
import { ReferenceValueSheetOverviewResolver } from './resolvers/reference-value-sheet-overview.resolver';
import { ReferenceValueSheetService } from './services/reference-value-sheet.service';
import { ReferenceValueSheetEffects } from './store/reference-value-sheet.effects';
import * as referenceValueSheetReducer from './store/reference-value-sheet.reducer';

export function provideReferenceValueSheetFeature() {
  return makeEnvironmentProviders([
    provideState('referenceValueSheetModule', referenceValueSheetReducer.reducer),
    provideEffects(ReferenceValueSheetEffects),
    ReferenceValueSheetService,
    ReferenceValueSheetOverviewResolver,
    GetReferenceValueSheetByIdResolver,
  ]);
}
